import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class Http {
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private httpClient: HttpClient) {
    }

    get<T>(url: string): Observable<T> {

        return this.httpClient
            .get<T>(url, this.httpOptions);
    }

    post<T>(url: string, data: any): Observable<T> {
        return this.httpClient
            .post<T>(url, JSON.stringify(data), this.httpOptions);
    }

    patch<T>(url: string, data: any): Observable<T> {

        return this.httpClient
            .patch<T>(url, JSON.stringify(data), this.httpOptions);
    }
}
